module.exports = __webpack_public_path__ + "img/23.11461e23.jpg";